/**
 * @TODO These have not been vetted by the design team.
 *
 * @MacroMackie has started consolidating them in one spot to make them easier
 * to manage/configure, but we should revisit this with someone from design.
 */

export const MDSAnimations = {
  fadeIn: {
    duration: 0.2,
  },
  fadeOut: {
    duration: 0.1,
  },
} as const;
